import React from 'react'
import { FAQ } from 'components/FAQ/index.js'
import FitnessToolsFAQItems from 'components/FitnessToolsFAQItems'

export function ToolsFAQ () {
  return (
    // eslint-disable-next-line react/jsx-pascal-case
    <FAQ
      itemsComponent={<FitnessToolsFAQItems />}
    />
  )
}
